import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import {DigitalContractService} from '../../../../../../../core/services/digital-contract.service';
import {CommonService} from '../../../../../../../core/services/common.service';
import {ToastrService} from 'ngx-toastr';
import { EnvService } from 'src/app/core/services/env.service';
import { LIMIT_SIZE } from 'src/app/core/constants/common';
import {DocumentService} from "../../../../../../../core/services/document.service";

@Component({
  selector: 'app-view-contract-business',
  templateUrl: './view-contract-business.component.html',
  styleUrls: ['./view-contract-business.component.scss']
})
export class ViewContractBusinessComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  activeFile = 0;
  pdfSrc;
  language: string;
  BASE_URL = 'http://localhost:8091/api';
  authorization: any;
  constructor(
    private digitalContractService: DigitalContractService,
    public commonService: CommonService,
    private documentService: DocumentService,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<ViewContractBusinessComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private env: EnvService
  ) {
    this.language = localStorage.getItem('__language') || 'vi';
    dialogRef.disableClose = false;
    this.changeFile(0);
    this.BASE_URL = this.env.is_private_app ? this.env.private_api_endpoint : this.env.public_api_endpoint;
    this.BASE_URL += '/file/view/digital/view-file';
    this.authorization = {
      Authorization: `Bearer ${sessionStorage.getItem('token')}`
    };
  }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }
  async doPrint() {
    // if(this.document.status !==this.EnumContractStatus.FINISHED ||
    //   (this.document.isConfirmBCT==true && this.document.bctConfirmStatus !== this.EnumContractStatus.FINISHED) ){
    //   this.callApiWaterMark()
    // }else{
    //   const currentFrame = document.getElementById('sample-iframe');
    //   if(currentFrame){
    //     currentFrame.remove()
    //   }
    //   // this.printService.print();
    //   if(this.isString(this.pdfSrc)){
    //     if(this.pdfSrc =='notPDF'){
    //       this.toastr.error(this.translateService.instant('messages.notPdf'))
    //       return
    //     }else if(this.pdfSrc.includes('file/view/contract')&&this.document.mainContractAttachments[this.activeFile].fileSize > LIMIT_SIZE){
    //       this.callApiWaterMark();
    //       return
    //     }
    //   }
    //
    //   if(this.pdfSrc.byteLength == undefined||this.pdfSrc.byteLength == 0){
    //     this.toastr.error(this.translateService.instant('messages.errorPdf'))
    //     return
    //   }
    //   this.pdfSrc = this.listPdfSrc[this.document.mainContractAttachments[this.activeFile].path];
    //   const buffer = this.pdfSrc;
    //   const blob = new Blob([buffer], {
    //     type: 'application/pdf'
    //   });
    //   const objectURL = URL.createObjectURL(blob);
    //
    //   // Create an iframe to demonstrate it:
    //   const iframe = document.createElement('iframe');
    //   iframe.id = 'sample-iframe';
    //   iframe.src = objectURL;
    //   document.body.appendChild(iframe);
    //   iframe.contentWindow.print();
    //   iframe.hidden = true
    // }
  }
  openPDFByBrowser(id: string) {
    if (id) {
      this.documentService.downloadFileZip(id).subscribe(res => {
        if (window.top.navigator.msSaveOrOpenBlob) {
          // Store Blob in IE
          window.top.navigator.msSaveOrOpenBlob(res, this.data.contractName+ '.zip');
        } else {
          // Store Blob in others
          const tA = document.body.appendChild(document.createElement('a'));
          tA.href = URL.createObjectURL(res);
          tA.download = this.data.contractName + '.zip';
          tA.style.display = 'none';
          tA.click();
          tA.parentNode.removeChild(tA);
        }
      });
    }
  }

  async changeFile(index: number) {
    const type = this.data.filesName[index].split('.').pop();
    if (type === 'pdf') {
      const pdfSrc = await this.viewDocumentUpload(this.data.id[index], this.data.filesName[index],this.data.listFileSize[index]);
      this.pdfSrc = pdfSrc;
    } else {
      this.pdfSrc = 'notPDF';
    }
    this.activeFile = index;
  }

  async viewDocumentUpload(id, fileName, size) {
    this.BASE_URL = this.env.is_private_app ? this.env.private_api_endpoint : this.env.public_api_endpoint;
    if (!this.env.pdfViewFullDownload && size >= LIMIT_SIZE) {
      this.BASE_URL += '/file/view/digital/view-file';
    } else {
      this.BASE_URL += '/file/view/digital/view-file-by-id';
    }
    const pdfSrc = `${this.BASE_URL}/${id}`;
    return pdfSrc;
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    // A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  };

  async showPdf(blob: any, fileName: string) {
    const file = this.blobToFile(blob, fileName);
    const pdfSrc = await this.commonService.readFileAsync(file);
    return pdfSrc;
  }
}
